(() => {
  const formatMoneyBRL = (cents) => {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const initGiftsProgress = (root) => {
    if (!root) return;

    const hideOnConsumer = root.getAttribute('data-hide-on-consumer') === 'true';
    if (hideOnConsumer && document.querySelector('.section-consumer-day')) {
      root.style.display = 'none';
      return;
    }

    let steps = [];
    try {
      steps = JSON.parse(root.getAttribute('data-steps') || '[]')
        .filter((step) => typeof step.threshold_cents === 'number' && step.threshold_cents > 0)
        .sort((a, b) => a.threshold_cents - b.threshold_cents);
    } catch (error) {
      steps = [];
    }

    const stepsNextEl = root.querySelector('.js-steps-next');
    const barsWrap = root.querySelector('.js-steps-bars');
    const floatingSummaryEnabled = root.getAttribute('data-floating-summary') === 'true';
    const summaryPanel = floatingSummaryEnabled ? root.querySelector('[data-floating-summary-panel]') : null;
    const floatingCard = floatingSummaryEnabled ? root.querySelector('[data-floating-card]') : null;
    const floatingBackdrop = floatingSummaryEnabled ? root.querySelector('[data-floating-backdrop]') : null;
    const floatingScopeId = floatingSummaryEnabled ? root.getAttribute('data-floating-scope') : null;
    let floatingScopeEl = floatingScopeId ? document.getElementById(floatingScopeId) : null;
    let scopeInView = !floatingScopeEl;
    let cartDrawerIsOpen = false;
    const summaryEls = summaryPanel
      ? {
          total: summaryPanel.querySelector('.js-steps-total'),
          discount: summaryPanel.querySelector('.js-steps-discount'),
          net: summaryPanel.querySelector('.js-steps-net'),
        }
      : null;
    const summaryCheckoutButton = summaryPanel?.querySelector('[data-summary-checkout]');
    const summaryCheckoutForm = floatingSummaryEnabled ? root.querySelector('[data-floating-checkout-form]') : null;
    const submitFloatingCheckoutForm = () => {
      if (!summaryCheckoutForm) return false;
      const form = summaryCheckoutForm;
      if (!form.querySelector('input[name="checkout"]')) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'checkout';
        hiddenInput.value = 'Checkout';
        form.appendChild(hiddenInput);
      }
      form.submit();
      return true;
    };

    if (summaryCheckoutButton) {
      summaryCheckoutButton.addEventListener('click', async () => {
        if (summaryCheckoutButton.disabled) return;
        summaryCheckoutButton.disabled = true;
        summaryCheckoutButton.classList.add('is-loading');

        const redirectTo = async () => {
          try {
            const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            if (!res.ok) throw new Error('cart.js response not ok');
            const cartJson = await res.json();
            if (cartJson?.checkout_url) {
              summaryCheckoutButton.dataset.checkoutUrl = cartJson.checkout_url;
              return cartJson.checkout_url;
            }
          } catch (error) {
            console.warn('Não foi possível recuperar checkout_url atualizado', error);
          }
          return (
            summaryCheckoutButton.dataset.checkoutUrl ||
            window.theme?.routes?.checkout_url ||
            window.theme?.routes?.cart_url ||
            '/checkout'
          );
        };

        const targetUrl = await redirectTo();
        const urlPath = (() => {
          try {
            const parsed = new URL(targetUrl, window.location.origin);
            return parsed.pathname || '';
          } catch (e) {
            return targetUrl || '';
          }
        })();

        const looksLikeCheckout = urlPath && !urlPath.startsWith('/cart');

        if (looksLikeCheckout) {
          window.location.href = targetUrl;
          return;
        }

        const fallbackHandled = submitFloatingCheckoutForm();
        if (!fallbackHandled) {
          window.location.href = targetUrl || window.theme?.routes?.checkout_url || '/checkout';
        }

        setTimeout(() => {
          summaryCheckoutButton.disabled = false;
          summaryCheckoutButton.classList.remove('is-loading');
        }, 300);
      });
    }

    const pctToColor = (pct) => {
      const clamped = Math.max(0, Math.min(1, pct));
      const hue = Math.round(120 * clamped);
      return `hsl(${hue} 70% 45%)`;
    };

    const renderStepBars = () => {
      if (!barsWrap) return;
      barsWrap.innerHTML = '';
      barsWrap.style.setProperty('--steps-count', String(steps.length || 1));

      steps.forEach((step, index) => {
        const bar = document.createElement('div');
        bar.className = 'step-bar';
        bar.setAttribute('data-threshold', String(step.threshold_cents));
        bar.setAttribute('data-index', String(index));
        bar.innerHTML = `
          <div class="step-bar__track">
            <div class="step-bar__fill"></div>
          </div>
          <div class="step-bar__label">${step.title || ''}</div>
        `;
        barsWrap.appendChild(bar);
      });
    };

    const updateStepBars = (totalCents) => {
      steps.forEach((step, index) => {
        const bar = barsWrap?.querySelector(`.step-bar[data-index="${index}"]`);
        if (!bar) return;
        const prev = index === 0 ? 0 : steps[index - 1].threshold_cents;
        const span = Math.max(1, step.threshold_cents - prev);
        const segmentProgress = Math.max(0, Math.min(1, (totalCents - prev) / span));
        const fill = bar.querySelector('.step-bar__fill');
        if (fill) {
          fill.style.width = `${(segmentProgress * 100).toFixed(2)}%`;
          fill.style.backgroundColor = pctToColor(segmentProgress);
        }
        bar.classList.toggle('achieved', segmentProgress >= 1);
      });
    };

    const applyFloatingVisibility = () => {
      if (!floatingSummaryEnabled || !floatingCard) return;
      const shouldShow = scopeInView && !cartDrawerIsOpen;
      floatingCard.classList.toggle('is-hidden', !shouldShow);
      if (floatingBackdrop) {
        floatingBackdrop.style.opacity = shouldShow ? '1' : '0';
      }
    };

    const updateFloatingSummary = (cart) => {
      if (!summaryEls) return;
      const subtotal = parseInt(cart?.original_total_price ?? cart?.items_subtotal_price ?? 0, 10) || 0;
      const discount = parseInt(cart?.total_discount ?? 0, 10) || 0;
      const net = parseInt(cart?.total_price ?? subtotal - discount, 10) || 0;
      if (summaryEls.total) summaryEls.total.textContent = formatMoneyBRL(subtotal);
      if (summaryEls.discount) summaryEls.discount.textContent = formatMoneyBRL(discount);
      if (summaryEls.net) summaryEls.net.textContent = formatMoneyBRL(net);
      if (summaryCheckoutButton && cart?.checkout_url) {
        summaryCheckoutButton.dataset.checkoutUrl = cart.checkout_url;
      }
      applyFloatingVisibility();
    };

    const refreshFromCart = async () => {
      if (!steps.length) {
        if (stepsNextEl) {
          stepsNextEl.textContent = 'Configure os steps no editor para ativar os brindes.';
          stepsNextEl.classList.remove('concluded');
        }
        if (barsWrap) barsWrap.innerHTML = '';
        return;
      }

      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = res.ok ? await res.json() : null;
        updateFloatingSummary(cart);
        const total = parseInt(
          cart?.original_total_price ??
          cart?.items_subtotal_price ??
          cart?.total_price ??
          0,
          10
        ) || 0;

        let nextIdx = -1;
        steps.forEach((step, index) => {
          const achieved = total >= step.threshold_cents;
          if (nextIdx === -1 && !achieved) nextIdx = index;
        });

        if (nextIdx === -1) {
          if (stepsNextEl) {
            stepsNextEl.textContent = 'Parabéns! Você alcançou todos os brindes disponíveis 🎉';
            stepsNextEl.classList.add('concluded');
          }
        } else {
          const nextStep = steps[nextIdx];
          const falta = Math.max(0, nextStep.threshold_cents - total);
          if (stepsNextEl) {
            const amountLine = `Faltam <strong>${formatMoneyBRL(falta)}</strong> para ganhar:`;
            const rewardLine = `<strong>${nextStep.title}</strong>.`;
            stepsNextEl.innerHTML = `${amountLine}<br>${rewardLine}`;
            stepsNextEl.classList.remove('concluded');
          }
        }

        updateStepBars(total);
      } catch (error) {
        // fail silently
      }
    };

    const getViewportHeight = () => window.innerHeight || document.documentElement.clientHeight || 0;
    const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth || 0;
    const isMobileViewport = () => getViewportWidth() <= 749;

    const reachedTriggerPoint = (rect, viewportHeight) => {
      if (!rect) return false;
      const topThreshold = viewportHeight * (isMobileViewport() ? 0.65 : 0.5);
      return rect.top <= topThreshold;
    };

    const isInViewport = (element) => {
      if (!element) return true;
      const rect = element.getBoundingClientRect();
      const viewportHeight = getViewportHeight();
      const viewportWidth = getViewportWidth();
      return rect.bottom > 0 && rect.right > 0 && rect.left < viewportWidth && reachedTriggerPoint(rect, viewportHeight);
    };

    const evaluateScopeVisibility = () => {
      if (!floatingScopeEl || !isMobileViewport()) {
        scopeInView = true;
        applyFloatingVisibility();
        return;
      }

      if (!floatingScopeEl.isConnected && floatingScopeId) {
        floatingScopeEl = document.getElementById(floatingScopeId);
      }
      scopeInView = isInViewport(floatingScopeEl);
      applyFloatingVisibility();
    };

    if (floatingScopeEl && 'IntersectionObserver' in window) {
      const scopeObserver = new IntersectionObserver((entries) => {
        if (!isMobileViewport()) {
          scopeInView = true;
          applyFloatingVisibility();
          return;
        }
        scopeInView = entries.some((entry) => {
          if (!entry.isIntersecting) return false;
          const viewportHeight = getViewportHeight();
          return entry.boundingClientRect.bottom > 0 && reachedTriggerPoint(entry.boundingClientRect, viewportHeight);
        });
        applyFloatingVisibility();
      }, { threshold: 0.35 });
      scopeObserver.observe(floatingScopeEl);
    }

    const scheduleScopeRecheck = () => {
      if (!floatingSummaryEnabled) return;
      requestAnimationFrame(() => {
        evaluateScopeVisibility();
      });
    };

    const forceHideFloatingCard = () => {
      if (!floatingSummaryEnabled || !floatingCard) return;
      floatingCard.classList.add('is-hidden');
      if (floatingBackdrop) floatingBackdrop.style.opacity = '0';
    };

    document.addEventListener('theme:cart:open', () => {
      if (!floatingSummaryEnabled) return;
      cartDrawerIsOpen = true;
      forceHideFloatingCard();
    });

    const queueMultipleScopeChecks = () => {
      [0, 120, 260].forEach((delay) => {
        setTimeout(() => {
          evaluateScopeVisibility();
        }, delay);
      });
    };

    document.addEventListener('theme:cart:close', () => {
      if (!floatingSummaryEnabled) return;
      cartDrawerIsOpen = false;
      refreshFromCart();
      queueMultipleScopeChecks();
    });

    const cartDrawerEl = document.querySelector('[data-cart-drawer]');
    if (cartDrawerEl && 'MutationObserver' in window) {
      const drawerObserver = new MutationObserver(() => {
        const isOpen = cartDrawerEl.classList.contains('is-open');
        cartDrawerIsOpen = isOpen;
        if (!isOpen) {
          queueMultipleScopeChecks();
        } else {
          forceHideFloatingCard();
        }
      });
      drawerObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    window.addEventListener('scroll', () => {
      if (!floatingSummaryEnabled || cartDrawerIsOpen) return;
      evaluateScopeVisibility();
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (!floatingSummaryEnabled || cartDrawerIsOpen) return;
      evaluateScopeVisibility();
    });

    renderStepBars();
    refreshFromCart();
    evaluateScopeVisibility();
    queueMultipleScopeChecks();

    document.addEventListener('theme:cart:update', () => {
      refreshFromCart();
      queueMultipleScopeChecks();
    });
    document.addEventListener('theme:cart:added', () => {
      refreshFromCart();
      queueMultipleScopeChecks();
    });
    document.addEventListener('theme:cart:loaded', refreshFromCart);
  };

  const initAll = () => {
    document.querySelectorAll('.js-gifts-progress:not([data-initialized])').forEach((root) => {
      root.setAttribute('data-initialized', 'true');
      initGiftsProgress(root);
    });
  };

  const syncVisibility = () => {
    const roots = Array.from(document.querySelectorAll('.js-gifts-progress'));
    if (!roots.length) return;

    const anyCartInstance = roots.some((root) => {
      return root.closest('.cart-drawer.is-open') || root.closest('[data-cart-page]');
    });

    roots.forEach((root) => {
      const isCartContext = Boolean(root.closest('.cart-drawer') || root.closest('[data-cart-page]'));
      if (anyCartInstance) {
        if (isCartContext) {
          root.style.removeProperty('display');
        } else {
          root.style.display = 'none';
        }
      } else {
        const hideOnConsumer = root.getAttribute('data-hide-on-consumer') === 'true';
        if (hideOnConsumer && document.querySelector('.section-consumer-day')) {
          root.style.display = 'none';
        } else {
          root.style.removeProperty('display');
        }
      }
    });
  };

  const rerunAll = () => {
    try {
      initAll();
      syncVisibility();
    } catch (error) {
      // noop
    }
  };

  rerunAll();
  document.addEventListener('readystatechange', rerunAll);
  document.addEventListener('DOMContentLoaded', rerunAll);
  document.addEventListener('theme:cart:loaded', rerunAll);
  document.addEventListener('theme:cart:open', rerunAll);
  document.addEventListener('theme:cart:close', syncVisibility);
  document.addEventListener('shopify:section:load', rerunAll);
  document.addEventListener('shopify:section:unload', syncVisibility);
  document.addEventListener('shopify:section:select', rerunAll);
  document.addEventListener('shopify:section:deselect', syncVisibility);
  document.addEventListener('shopify:block:select', rerunAll);
  document.addEventListener('shopify:block:deselect', syncVisibility);

  try {
    const observer = new MutationObserver(rerunAll);
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  } catch (error) {
    // noop
  }
})();
